<template>
  <el-dialog
    v-model="dailyPopupVisible"
    :width="popupWidth"
    align-center
    :show-close="true"
    class="daily-popup"
  >
    <div style="text-align: center">
      <NuxtLink to="/mypage#campaign" @click="closeDailyPopup" id="cp_popup_link">
        <CommonsResponsiveImage :src="popupImageSrc" alt="Campaign" class="popup-image" />
      </NuxtLink>
    </div>
  </el-dialog>
</template>

<script setup lang="ts">
import { useDeviceCheck } from '@/composables/useDeviceCheck';

const { dailyPopupVisible, closeDailyPopup } = useDailyPopup();
const { isLargeScreen } = useDeviceCheck();
const { awsS3Url } = useRuntimeConfig().public;

const now = new Date();
const year = String(now.getFullYear()).slice(-2);
const month = String(now.getMonth() + 1).padStart(2, '0');
const popupImageSrc = `${awsS3Url}popup/campaign_pop_${year}${month}_pc.jpg`;

const popupWidth = computed(() => (isLargeScreen.value ? '800px' : '90%'));
</script>

<style>
.popup-image {
  width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
}
.daily-popup .el-dialog__header {
  padding: 0;
  margin-right: 0;
}
.daily-popup .el-dialog__header .el-dialog__headerbtn {
  top: 5px;
  right: 5px;
  width: 40px;
  height: 40px;
  z-index: 10;
}
.daily-popup .el-dialog__header .el-dialog__headerbtn .el-dialog__close {
  font-size: 30px;
  color: #fff;
  filter: drop-shadow(0 0 3px rgba(0, 0, 0, 0.5));
}
.daily-popup .el-dialog__body {
  padding: 0;
  font-size: 0;
}
.daily-popup.el-dialog {
  padding: 0;
}
</style>
